module.exports = __webpack_public_path__ + "static/media/estate-fallback.10f70080.png";